/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The standard genetic code (NCBI translation table 1), which applies to most nuclear genes. Organelle and some organism-specific codes differ for a few codons.`)
};

const es_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El código genético estándar (tabla de traducción 1 del NCBI), que se aplica a la mayoría de los genes nucleares. Los códigos de orgánulos y algunos específicos de organismos difieren en unos pocos codones.`)
};

const de_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Standard-genetische Code (NCBI-Übersetzungstabelle 1), der für die meisten Kerngene gilt. Organellen- und einige organismenspezifische Codes unterscheiden sich bei einigen Codons.`)
};

const nl_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De standaard genetische code (NCBI-vertaaltabel 1), die van toepassing is op de meeste kerngenen. De codes van organellen en enkele organisme-specifieke codes verschillen voor een paar codons.`)
};

const fr_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le code génétique standard (table de traduction 1 du NCBI), qui s'applique à la plupart des gènes nucléaires. Les codes des organites et de certains organismes spécifiques diffèrent pour quelques codons.`)
};

const it_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il codice genetico standard (tabella di traduzione NCBI 1), che si applica alla maggior parte dei geni nucleari. I codici degli organelli e alcuni codici specifici di organismo differiscono per alcuni codoni.`)
};

const pt_br2_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código genético padrão (tabela de tradução 1 do NCBI), que se aplica à maioria dos genes nucleares. Códigos de organelas e específicos de alguns organismos diferem em poucos códons.`)
};

const pt_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O código genético padrão (tabela de tradução 1 do NCBI), que se aplica à maioria dos genes nucleares. Os códigos de organelos e alguns códigos específicos de organismos diferem em alguns codões.`)
};

const ja_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`標準遺伝暗号（NCBI翻訳テーブル1）で、ほとんどの核遺伝子に適用されます。オルガネラや一部の生物特有のコードは、いくつかのコドンで異なります。`)
};

const zh_translate_faq_a2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标准遗传密码（NCBI 翻译表 1），适用于大多数核基因。细胞器及部分特定生物的密码在少数密码子上有所不同。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const translate_faq_a2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.translate_faq_a2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("translate_faq_a2", locale)
	if (locale === "en") return en_translate_faq_a2(inputs)
	if (locale === "es") return es_translate_faq_a2(inputs)
	if (locale === "de") return de_translate_faq_a2(inputs)
	if (locale === "nl") return nl_translate_faq_a2(inputs)
	if (locale === "fr") return fr_translate_faq_a2(inputs)
	if (locale === "it") return it_translate_faq_a2(inputs)
	if (locale === "pt-BR") return pt_br2_translate_faq_a2(inputs)
	if (locale === "pt") return pt_translate_faq_a2(inputs)
	if (locale === "ja") return ja_translate_faq_a2(inputs)
	return zh_translate_faq_a2(inputs)
};